import { render, staticRenderFns } from "./login_forget_pwd.vue?vue&type=template&id=11c06488&scoped=true"
import script from "./login_forget_pwd.vue?vue&type=script&lang=js"
export * from "./login_forget_pwd.vue?vue&type=script&lang=js"
import style0 from "./login_forget_pwd.vue?vue&type=style&index=0&id=11c06488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c06488",
  null
  
)

export default component.exports